import { BlockStack, Button, Card, InlineStack, Text } from '@shopify/polaris';
import TextToImage from '@/components/images/TextToImage';
import { ImagesModalSectionProps } from '@/features/media-modal/components/common/commonTypes';
import { AssetCreationToolName, GenerationInstrument, StandaloneMediaAsset } from '@/types/media';
import { useState } from 'react';
import { useTextToImage } from '@/hooks/image';
import { PricesService } from '@/features/billing';
import { useInsufficientBalance } from '@/features/billing/components/InsufficientBalanceContext';

export type AiImagesModalSectionProps = ImagesModalSectionProps;

const CREDITS = PricesService.getPriceText(AssetCreationToolName.textToImage, [GenerationInstrument.textToImage]);
const CREDITS_TEXT = CREDITS ? ` (${CREDITS})` : '';

export const AiImagesModalSection = ({ recommendation, product }: AiImagesModalSectionProps) => {
  const [prompt, setPrompt] = useState(recommendation?.stockMediaQuery || '');
  const { isGenerating, isError, generatedMediaAsset, handleGenerate } = useTextToImage();
  const { checkBalance } = useInsufficientBalance();
  const handleGenerateClick = () => {
    if (!checkBalance(AssetCreationToolName.textToImage, [GenerationInstrument.textToImage])) return;
    handleGenerate({
      prompt,
      productId: product?.productId,
      productTitle: product?.title,
    });
  };
  return (
    <BlockStack gap="400">
      <Text as="h2" variant="headingMd" fontWeight="bold">
        Create AI Image
      </Text>
      <Card>
        <BlockStack gap="200">
          <Text as="p" variant="bodyMd">
            Describe the image you want to create
          </Text>

          <TextToImage
            generatedMediaAsset={generatedMediaAsset as StandaloneMediaAsset}
            prompt={prompt}
            setPrompt={setPrompt}
            isGenerating={isGenerating}
            isError={isError}
            hideUseAction
          />
        </BlockStack>
      </Card>
      <InlineStack align="end">
        <Button
          size="large"
          onClick={handleGenerateClick}
          disabled={isGenerating || !prompt.trim()}
          loading={isGenerating}
        >
          Generate{CREDITS_TEXT}
        </Button>
      </InlineStack>
    </BlockStack>
  );
};
